const HEX_ADDR = /\s0[xX][0-9a-fA-F]+\s/;
const PAREN_SOURCE = /^(.*)(\(\S+?\.\S+?:\d+.*\))(.*)$/;

/** iOS/Mac 没有 0x 地址的 `at 函数 (文件.扩展名:行:列)`。原生帧交给原解析。 */
export function extractIosParenFilePath(line) {
  const text = String(line || '');
  if (!text || HEX_ADDR.test(text)) {
    return null;
  }
  const matched = text.match(PAREN_SOURCE);
  if (!matched) {
    return null;
  }
  const filePath = matched[2].slice(1, -1);
  if (!filePath) {
    return null;
  }
  return {
    stackContentBeforeFilePath: matched[1],
    filePath,
    stackContentAfterFilePath: matched[3] || '',
  };
}
